import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const StockParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Stock Parliament" />;
};

export default StockParliament;
